import React from 'react'

function Result({ result, openPopup }) {
	console.log(result);
    return (
		
        <div className="col-sm-12 col-md-4 col-lg-4">
				<div className="card my-2">
					<img src={result.recipe.image} className="card-img-top img-fluid"  onError={(e)=>{e.target.onerror = null; e.target.src="default.png"}}></img>
					<div className="card-body">
						<div className="title" >{result.recipe.label}</div>
						<ul className="card-ul">
						<li >Cuisine: {result.recipe.cuisineType}</li>
						<li ><span><i class="fas fa-fire"></i></span> {Math.floor(result.recipe.calories)} Cal</li>
						<li ><span><i class="fas fa-stopwatch"></i></span> {result.recipe.totalTime} mins</li>
						</ul>
						<a href="#" onClick={() => {openPopup(result.recipe.uri.slice(44))}}className="btn btn-sm col-sm-12 col-md-6">View Recipe</a>
					</div>
				</div>
			</div>
			
			

    )
}

export default Result
